import { render, staticRenderFns } from "./transcation.vue?vue&type=template&id=54abda74&"
import script from "./transcation.vue?vue&type=script&lang=js&"
export * from "./transcation.vue?vue&type=script&lang=js&"
import style0 from "./transcation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports